{
  "clubId": "club-user",
  "availableBalance": 45000000,
  "reservedBalance": 5000000,
  "totalBalance": 50000000,
  "currency": "EUR",
  "version": 1
}
